import { SUPPORTED_CHAINS } from '../utils/constants';

const NetworkIcon = ({ network }) => {
  if (network === 'Arc Testnet') {
    return (
      <svg className="h-6 w-6 sm:h-7 sm:w-7" viewBox="0 0 24 24" fill="none">
        <path d="M12 3L4 21h3.5l1.5-4h6l1.5 4H20L12 3z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  if (network === 'Base Sepolia') {
    return (
      <svg className="h-5 w-5 sm:h-6 sm:w-6" viewBox="0 0 111 111" fill="none">
        <path d="M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z" fill="white"/>
      </svg>
    );
  }
  if (network === 'ETH Sepolia') {
    return (
      <svg className="h-5 w-5 sm:h-6 sm:w-6" viewBox="0 0 784 784" fill="none">
        <path d="M392 0L386.5 18.7V535.8L392 541.3L632 400.5L392 0Z" fill="white" fillOpacity="0.6"/>
        <path d="M392 0L152 400.5L392 541.3V289.8V0Z" fill="white"/>
        <path d="M392 586.9L389 590.6V784L392 784L632.2 445.1L392 586.9Z" fill="white" fillOpacity="0.6"/>
        <path d="M392 784V586.9L152 445.1L392 784Z" fill="white"/>
      </svg>
    );
  }
  if (network === 'Unichain Sepolia') {
    return (
      <svg className="h-5 w-5 sm:h-6 sm:w-6" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill="white"/>
      </svg>
    );
  }
  if (network === 'World Chain Sepolia') {
    return (
      <svg className="h-5 w-5 sm:h-6 sm:w-6" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2"/>
        <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="2"/>
        <circle cx="12" cy="12" r="1" fill="white"/>
      </svg>
    );
  }
  // Default
  return (
    <svg className="h-5 w-5 sm:h-6 sm:w-6" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
    </svg>
  );
};

const getNetworkColor = (network) => {
  switch (network) {
    case 'Arc Testnet': return 'bg-blue-600 border-blue-600';
    case 'Base Sepolia': return 'bg-blue-600 border-blue-600';
    case 'ETH Sepolia': return 'bg-gray-700 border-gray-700';
    case 'Unichain Sepolia': return 'bg-pink-600 border-pink-600';
    case 'World Chain Sepolia': return 'bg-black border-black';
    default: return 'bg-blue-600 border-blue-600';
  }
};

const NetworkCard = ({ type, network, token, chainId, onChainChange, disabledChainId }) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-gray-700">{type}</label>
      <div className="flex items-center justify-between rounded-xl border-2 border-gray-200 bg-gray-50 p-4 transition-all hover:border-gray-300">
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Network Icon */}
          <div className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 ${getNetworkColor(network)} sm:h-12 sm:w-12`}>
            <NetworkIcon network={network} />
          </div>

          {/* Network Selector */}
          <div className="min-w-0 flex-1">
            {onChainChange ? (
              <select
                value={chainId}
                onChange={(e) => onChainChange(Number(e.target.value))}
                className="w-full appearance-none bg-transparent text-base font-bold text-black outline-none cursor-pointer pr-6 truncate"
              >
                {SUPPORTED_CHAINS.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            ) : (
              <div className="truncate text-base font-bold text-black">
                {network}
              </div>
            )}
            <div className="text-sm font-medium text-gray-600">
              Testnet
            </div>
          </div>
        </div>

        {/* Token Badge */}
        <div className="flex-shrink-0 rounded-lg bg-blue-600 px-3 py-1.5 text-sm font-bold text-white shadow-sm">
          {token}
        </div>
      </div>
    </div>
  );
};

export default NetworkCard;
